import _ from "lodash";
import React from "react";
import ReactDOMServer from "react-dom/server";
import update from "immutability-helper";
import {
  MagicWandThreeStarsOutlined,
  ReloadArrowOutlined,
  FourLinesOutlined,
  TwoLinesOutlined,
  DeleteOutlined,
  TickLargeOutlined,
  BroomOutlined,
  AddCircleOutlined,
  SpannerOutlined,
  EyeOutlined,
  HashtagOutlined,
  AnalyticsOutlined,
  SearchOutlined,
  SettingsOutlined,
  StudentOutlined,
  FamilyOutlined,
  ClassChannelOutlined,
  FamilyChannelOutlined,
  CustomChannelOutlined,
  ImageSquareOutlined,
  SheetsOutlined,
  VolumeHighOutlined,
  PdfOutlined,
  FlagOutlined,
  CommentOutlined,
  PageSquareOutlined,
  ChatTextFilled,
  FlagFilled,
  EyeFilled,
  SmileySatisfiedEyesOutlined,
  SmileySatisfiedEyesFilled,
  VideoOutlined,
  LinkOutlined,
  SettingsFilled,
  SlidesOutlined,
  ZipFileOutlined,
  DeviceDesktopOutlined,
  GoogleDriveColored,
  OneDriveColored,
  CameraOutlined,
  GlobeOutlined,
  SpiralBookLinesOutlined,
  PageFoldPortraitOutlined,
  PollOutlined,
  AddOutlined,
  AssessmentAddOutlined,
} from "@toddle-edu/ds-icons";

import { colors } from "Constants";
import {
  highlightText,
  highlightTextWithCustomStyle,
} from "Utils/highlightText";
import {
  STAFF,
  STUDENT,
  PARENT,
  YEAR_GROUP,
  GRADE,
  CLASSES,
} from "Constants/stringConstants";
import { getIsAdminByRole } from "lib/staffPermissionUtils";
import {
  getDefaultOrderBy,
  getFormattedUserName,
} from "Utils/GetFormattedUserName";
import {
  getOrganizationId,
  getUserType,
  getIsStaff,
  getIsStudent,
  getUserId,
  getUserEntityType,
  getUserCurriculumPrograms,
  getIsParent,
} from "modules/CommonSelectors";
import moment from "moment";
import ACLStore from "lib/aclStore";
import { isIdEqual } from "Utils/idHelpers";
import { generateRandomId } from "Utils/GenerateRandomId";
import { recordEvent } from "lib/eventTracker";
import { getTimeSince, parseConfigurationValue } from "Utils";
import {
  generateConfigurationQueryVariables,
  generateConfigurationQueryVariablesMemoized,
} from "ChildrenPage/modules/ChildrenPageUtils";

import { getConfigurationsFromCacheV2 } from "ChildrenPage/modules/ChildrenPageGraphqlHelpers";
import { getPlatformUserDetailsFromCache } from "modules/CommonGraphqlHelpers";

import {
  getConfigurationQueryFromCache,
  getChildrenYearGroupGradeFromCache,
} from "MessagingV2/components/Settings/modules/SettingGraphqlHelper";
import {
  CONFIGURATION,
  MESSAGING_GRADE_LEVEL_CONFIGS,
  MESSAGING_MODULE_GRADE_LEVEL_CONFIG,
} from "MessagingV2/components/Settings/modules/SettingsUtils";

import {
  getStaffRnpFilterCoursesCountFromCache,
  readMessageFromCache,
} from "./MessagingGraphqlHelper";
import { getTotalChatAndChannelCountQueryFromCache } from "../components/ThreadList/Utils/ThreadListGraphqlHelpers";
import ACLStorage from "lib/aclService";
import { ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION } from "Constants/permissionConstants";
import { checkIfPermissionIsEnabledInAnyCurriculum } from "Platform/modules/PlatformUtils";
import { getIsModuleSettingsV2Enabled } from "Utils/ACLStoreUtils";
import { getSettingValue } from "modules/PermissionModule";

let store;
import("store/createStore").then(importedModule => {
  store = importedModule.store;
});

export const SUB_TEXT_LENGTH = 50;
export const SUB_TEXT_LENGTH_V2 = 40;

export const ADD_MEMBERS_OPTION_LIST = [
  {
    label: "common:add_to_channel_title",
    subText: "common:add_to_channel_subtext",
    value: "ADD_MEMBER",
  },
  {
    label: "common:create_new_channel_title",
    subText: "common:create_new_channel_subtext",
    value: "CREATE_NEW_CHANNEL",
  },
];

export const CREATE_CHANNEL_CATEGORY = {
  CUSTOM_CHANNEL: "CUSTOM_CHANNEL",
  FAMILY_CHANNEL: "FAMILY_CHANNEL",
  PUBLIC_CHANNEL: "PUBLIC_CHANNEL",
  DEPARTMENT_CHANNEL: "DEPARTMENT_CHANNEL",
};

export const MESSAGING_ANALYTICS_EVENT_NAME = {
  MESSAGING_OPENED: "MESSAGING_OPENED",
  MESSAGING_WIDGET_EXPAND: "MESSAGING_WIDGET_EXPAND",
  MESSAGING_FILTER: "MESSAGING_FILTER",
  THREAD_TAB_CHANGED: "THREAD_TAB_CHANGED",
  MESSAGING_ADMIN_PANEL_OPENED: "MESSAGING_ADMIN_PANEL_OPENED",
  CHAT_ACCESSED: "CHAT_ACCESSED",
  CHANNEL_CREATED: "CHANNEL_CREATED",
  CHAT_ACTIONS: "CHAT_ACTIONS",
  CHANNEL_ACTIONS: "CHANNEL_ACTIONS",
  MESSAGE_ACTIONS: "MESSAGE_ACTIONS",
  MESSAGING_SEARCH_RESULT_SELECT: "MESSAGING_SEARCH_RESULT_SELECT",
  MESSAGING_SEARCH_FILTER: "MESSAGING_SEARCH_FILTER",
  MESSAGING_MODULE_SETTING_UPDATE: "MESSAGING_MODULE_SETTING_UPDATE",
  MESSAGING_VIEW_MODE_OPENED: "MESSAGING_VIEW_MODE_OPENED",
  // new events specific to messaging v2
  VIEW_CONVERSATION_CLICKED: "VIEW_CONVERSATION_CLICKED",
  OVERVIEW_ACTION: "OVERVIEW_ACTION",
  PAGE_VISITED: "PAGE_VISITED",

  MESSAGING_SEARCH_PAGE_TAB: "MESSAGING_SEARCH_PAGE_TAB",
  MESSAGING_SEARCH_PAGE_OPTION_SELECT: "MESSAGING_SEARCH_PAGE_OPTION_SELECT",
  OVERVIEW_SEARCH_RESULT_SELECT: "OVERVIEW_SEARCH_RESULT_SELECT",
  OVERVIEW_CHAT_OPENED: "OVERVIEW_CHAT_OPENED",
  SUGGESTION_PRESSED: "SUGGESTION_PRESSED",
};

export const MESSAGING_VERSION = {
  V1: "V1",
  V2: "V2",
};

export const OVERVIEW_ACTION = {
  FLAGGED_MESSAGE_CLICKED: "FLAGGED_MESSAGE_CLICKED",
  FLAGGED_MESSAGE_WINDOW_OPENED: "FLAGGED_MESSAGE_WINDOW_OPENED",
};

export const SEARCH_PAGE_ACTION = {
  MEMBER: "MEMBER",
  CHANNEL: "CHANNEL",
  FILE: "FILE",
  MESSAGE: "MESSAGE",
  NAVIGATE_MESSAGE: "NAVIGATE_MESSAGE",
  NAVIGATE_FILE: "NAVIGATE_FILE",
  NAVIGATE_CHANNEL: "NAVIGATE_CHANNEL",
  NAVIGATE_MEMBER: "NAVIGATE_MEMBER",
  DOWNLOAD_FILE: "DOWNLOAD_FILE",
};

export const MESSAGING_FILTERS_CONSTANTS = {
  ALL: "ALL",
  UNREAD: "UNREAD",
  STUDENT: "STUDENT",
  FAMILY: "FAMILY",
  STAFF: "STAFF",
  PUBLIC_CHANNEL: "PUBLIC_CHANNEL",
  DEPARTMENT_CHANNEL: "DEPARTMENT_CHANNEL",
};

export const MESSAGING_SUGGESTION_PLACE = {
  CHIP: "CHIP",
  MODAL: "MODAL",
};

export const MESSAGING_SCREEN = {
  ANALYTICS: "ANALYTICS",
  OVERVIEW: "OVERVIEW",
  FLAGGED: "FLAGGED",
};

export const MESSAGING_MODULE_OPENED_FROM = {
  DASHBOARD: "DASHBOARD",
  ADMIN_PORTAL: "ADMIN_PORTAL",
  MAGIC_TRAY: "MAGIC_TRAY",
  GLOBAL_ACCESS_POINT: "GLOBAL_ACCESS_POINT",
  MESSAGING_MODULE: "MESSAGING_MODULE",
};

export const MESSAGING_MODULE_CHANNEL_CREATED_FROM = {
  MESSAGING_MODULE: "MESSAGING_MODULE",
  GLOBAL_ACCESS_POINT: "GLOBAL_ACCESS_POINT",
  ADMIN_PANEL: "ADMIN_PANEL",
  MAGIC_TRAY: "MAGIC_TRAY",
};

export const MESSAGING_ACTIONS_FROM = {
  CHAT_ACTIONS: "CHAT_ACTIONS",
  FOOTER: "FOOTER",
};

export const MESSAGING_ACTIONS = {
  MUTE: "MUTE",
  UNMUTE: "UNMUTE",
  ARCHIVE: "ARCHIVE",
  UNARCHIVE: "UNARCHIVE",
  JOIN: "JOIN",
  BASIC_INFORMATION: "BASIC_INFORMATION",
  MEMBERS: "MEMBERS",
  CHANNEL_SETTING: "CHANNEL_SETTING",
  CREATE_POLL: "CREATE_POLL",
  FORM_TEMPLATE: "FORM_TEMPLATE",
};

export const MESSAGING_SEARCH_TYPES = {
  IN_CURRENT_CHAT: "IN_CURRENT_CHAT",
  STAFF: "STAFF",
  PARENT: "PARENT",
  STUDENT: "STUDENT",
  RECENT_SEARCH: "RECENT_SEARCH",
  CHANNEL: "CHANNEL",
  ALL_MESSAGES: "ALL_MESSAGES",
  USER: "USER",
  MEMBERS: "MEMBERS",
  MESSAGES: "MESSAGES",
  FILES: "FILES",
};

export const CHAT_TYPE = {
  CHAT: "chat",
  CHANNEL: "channel",
};

export const CHAT_TYPE_BE = {
  CHAT_PERSONAL: "CHAT_PERSONAL",
  CHANNEL_SYSTEM_MANAGED: "CHANNEL_SYSTEM_MANAGED",
  CHANNEL_CUSTOM: "CHANNEL_CUSTOM",
  CHANNEL_FAMILY: "CHANNEL_FAMILY",
  CHANNEL_PUBLIC: "CHANNEL_PUBLIC",
  CHANNEL_DEPARTMENT: "CHANNEL_DEPARTMENT",
};

export const CHAT_SCREEN_MODE = {
  WIDGET: "widget",
  FULL_SCREEN: "full",
  VIEW_MODE_SCREEN: "view_mode",
  SIDE_PANE: "side_pane",
};

export const CHAT_SCREEN_TYPE = {
  SEARCH: "search",
};

export const MESSAGE_TYPE = {
  NORMAL: "NORMAL",
  CHANNEL_ACTIVITY: "CHANNEL_ACTIVITY",
  CONVERSATION_SUMMARY: "CONVERSATION_SUMMARY",
  FORWARDED_MESSAGE: "FORWARDED_MESSAGE",
  INTERACTION: "INTERACTION",
};

export const INTERACTION_TYPE = {
  POLL: "POLL",
  FORM: "FORM",
};

export const NOTIFICATION_TYPES = {
  CONV_MESSAGE_DELETE: "CONV_MESSAGE_DELETE",
};

// For the successful sent messages, we will have the status as undefined
export const MESSAGE_STATUS = {
  SENDING: "SENDING",
  FAILED: "FAILED",
};

export const MESSAGING_AI_ACTIONS = {
  GENERATE_SUGGESTIONS: "GENERATE_SUGGESTIONS",
  GENERATE_RESPONSE: "GENERATE_RESPONSE",
  CHANGE_THIS_TEXT: "CHANGE_THIS_TEXT",
  SUMMARISE: "SUMMARISE",
  ELABORATE: "ELABORATE",
  SHORTEN: "SHORTEN",
  IMPROVE_WRITING: "IMPROVE_WRITING",
  SIMPLIFY_WRITING: "SIMPLIFY_WRITING",
  SPELLING_AND_GRAMMAR: "SPELLING_AND_GRAMMAR",
};

export const MESSAGING_AI_PROMPT_ACTIONS = {
  KEEP: "KEEP",
  REPLACE: "REPLACE",
  ADD_BELOW: "ADD_BELOW",
  REGENERATE: "REGENERATE",
  DISCARD: "DISCARD",
};

export const ADD_MEMBERS_COHORTS = {
  YEAR_GROUP: "YEAR_GROUP",
  GRADE: "GRADE",
  CLASSES: "CLASSES",
};

export const FORWARDED_MESSAGE_LIMIT = 20;

export const promptsIconMapping = {
  [MESSAGING_AI_PROMPT_ACTIONS.ADD_BELOW]: (
    <AddCircleOutlined variant="subtle" />
  ),
  [MESSAGING_AI_PROMPT_ACTIONS.REPLACE]: <TickLargeOutlined variant="subtle" />,
  [MESSAGING_AI_PROMPT_ACTIONS.KEEP]: <TickLargeOutlined variant="subtle" />,
  [MESSAGING_AI_PROMPT_ACTIONS.REGENERATE]: (
    <ReloadArrowOutlined variant="subtle" />
  ),
  [MESSAGING_AI_PROMPT_ACTIONS.DISCARD]: <DeleteOutlined variant="subtle" />,
  [MESSAGING_AI_PROMPT_ACTIONS.ELABORATE]: (
    <FourLinesOutlined variant="subtle" />
  ),
  [MESSAGING_AI_PROMPT_ACTIONS.SHORTEN]: <TwoLinesOutlined variant="subtle" />,
  [MESSAGING_AI_PROMPT_ACTIONS.SIMPLIFY_LANGUAGE]: (
    <BroomOutlined variant="subtle" />
  ),
  [MESSAGING_AI_PROMPT_ACTIONS.IMPROVE_LANGUAGE]: (
    <MagicWandThreeStarsOutlined variant="subtle" />
  ),
  [MESSAGING_AI_PROMPT_ACTIONS.FIX_SPELLING_GRAMMAR]: (
    <SpannerOutlined variant="subtle" />
  ),
};

export const AI_MESSAGING_FIELD_AND_ACTION = {
  [MESSAGING_AI_ACTIONS.GENERATE_SUGGESTIONS]: {
    fieldType: "MESSAGING_AI_GENERATE_SUGGESTION",
    action: "suggestions",
    entityType: "MESSAGING_AI",
    type: "MESSAGING_AI_GENERATE_SUGGESTION",
  },
  [MESSAGING_AI_ACTIONS.GENERATE_RESPONSE]: {
    fieldType: "MESSAGING_AI_DRAFT_MESSAGE",
    action: "generate",
    entityType: "MESSAGING_AI",
    type: "MESSAGING_AI_DRAFT_MESSAGE",
  },
  [MESSAGING_AI_ACTIONS.SUMMARISE]: {
    fieldType: "MESSAGING_AI_SUMMARISE_CHAT",
    action: "summarise",
    entityType: "MESSAGING_AI",
    type: "MESSAGING_AI_SUMMARISE_CHAT",
  },
  [MESSAGING_AI_ACTIONS.CHANGE_THIS_TEXT]: {
    fieldType: "MESSAGING_AI_CHANGE_THIS",
    action: "change_this",
    entityType: "MESSAGING_AI",
    type: "MESSAGING_AI_CHANGE_THIS",
  },
  [MESSAGING_AI_ACTIONS.ELABORATE]: {
    fieldType: "ENHANCE",
    action: "elaborate",
    entityType: "GENERIC_TEXT",
    module: "MESSAGING_AI",
  },
  [MESSAGING_AI_ACTIONS.SHORTEN]: {
    fieldType: "ENHANCE",
    action: "shorten",
    entityType: "GENERIC_TEXT",
    module: "MESSAGING_AI",
  },
  [MESSAGING_AI_ACTIONS.IMPROVE_WRITING]: {
    fieldType: "ENHANCE",
    action: "improve_writing",
    entityType: "GENERIC_TEXT",
    module: "MESSAGING_AI",
  },
  [MESSAGING_AI_ACTIONS.SIMPLIFY_WRITING]: {
    fieldType: "ENHANCE",
    action: "simplify_writing",
    entityType: "GENERIC_TEXT",
    module: "MESSAGING_AI",
  },
  [MESSAGING_AI_ACTIONS.SPELLING_AND_GRAMMAR]: {
    fieldType: "ENHANCE",
    action: "check_for_spelling_and_grammar",
    entityType: "GENERIC_TEXT",
    module: "MESSAGING_AI",
  },
};

export const MESSAGING_SECTIONS = {
  CHAT: CHAT_TYPE.CHAT,
  CHANNELS: CHAT_TYPE.CHANNEL,
  SEARCH: "search",
  SETTINGS: "settings",
  MONITOR: "monitor",
  ANALYSIS: "analysis",
  UNDER_LINE: "UNDER_LINE",
  FLAGGED: "flagged",
  SENTIMENT: "sentiment",
  DIRECTORY: "directory",
};

export const SEARCH_ALL_SCREEN_TABS_CONSTANTS = {
  MESSAGES: "MESSAGES",
  MEMBERS: "MEMBERS",
  CHANNELS: "CHANNELS",
  FILES: "FILES",
};

export const OVERVIEW_AND_SETTING_CHANNEL_TABS_CONSTANTS = {
  ABOUT: "ABOUT",
  MEMBERS: "MEMBERS",
  SETTINGS: "SETTINGS",
};

const MESSAGING_USER_TYPE_CONFIG = {
  [STAFF]: "Setting:MessagingV2ForTeacher",
  [PARENT]: "Setting:MessagingV2ForFamily",
  [STUDENT]: "Setting:MessagingV2ForStudent",
};

const MODIFY_MESSAGE_CONFIG = {
  [STAFF]: "Setting:CanStaffModifyTheirMessage",
  [PARENT]: "Setting:CanFamilyModifyTheirMessage",
  [STUDENT]: "Setting:CanStudentModifyTheirMessage",
};

export const INITIATE_CONVERSATION_CONFIG = {
  [PARENT]: "Setting:CanFamilyInitiateChat",
  [STUDENT]: "Setting:CanStudentInitiateChat",
};

const RNP_CAN_VIEW_MESSAGING_MODULE = "Module:Messaging";

export const RNP_CAN_CREATE_AND_MANAGE_CHATS_AND_CHANNELS =
  "Messaging:CanCreateAndManageChatsAndChannels";

const RNP_CAN_VIEW_MESSAGING_INSIGHTS = "Messaging:CanViewMessagingInsights";

const RNP_CAN_VIEW_FLAGGED_MESSAGES = "Messaging:CanViewFlaggedMessages";

const RNP_CAN_VIEW_ALL_CONVERSATIONS = "Messaging:CanViewAllConversations";

const RNP_CAN_MANAGE_MESSAGING_SETTINGS =
  "Messaging:CanManageMessagingSettings";
const RNP_CAN_MANAGE_CHANNELS_THEY_ARE_ADDED_TO =
  "Messaging:CanManageChannelsTheyAreAddedTo";
const RNP_CAN_MODIFY_THEIR_MESSAGE = "Messaging:CanModifyTheirMessages";
export const RNP_CAN_CREATE_AND_MANAGE_CHATS_AND_CHANNELS_FOR_CLASS =
  "Messaging:CanCreateAndManageChatsAndChannelsForClass";

const AI_GENERATE_PERMISSION = "FeatureFlag:MessagingAIGenerateReply";
const AI_SUMMARISE_PERMISSION = "FeatureFlag:MessagingAISummariseChat";

export const PUBLIC_CHANNEL_CONFIG = "FeatureFlag:ConnectPublicChannels";

export const MESSAGING_FILTER_PREFERENCE_CONFIG =
  "Setting:ConnectChatsFilterConfiguration";

export const DUAL_PANEL_MANAGER_V2_CONFIG = "FeatureFlag:DualPanelManagerV2";
export const DUAL_PANEL_MANAGER_V3_CONFIG = "FeatureFlag:DualPanelManagerV3";

export const USER_CHAT_ACTIVITY_LOG_CONFIG = "FeatureFlag:LogUserChatActivity";

export const MESSAGING_FILTER_PREFERENCE_CONFIG_ID = "185959585964628155";
export const isMessagingRnpEnabled = () => {
  return ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);
};

export const isMessagingPublicChannelEnabled = () =>
  isMessagingV2ChannelEnabled() && ACLStore.can(PUBLIC_CHANNEL_CONFIG);

export const isMessagingDepartmentChannelEnabled = () =>
  isMessagingV2ChannelEnabled() && ACLStore.can(STAFF_DIRECTORY_PERMISSION);

export const isChannelSplitFeatureEnabled = () =>
  isMessagingPublicChannelEnabled() || isMessagingDepartmentChannelEnabled();

export const isReadReceiptOptimizationEnabled = () =>
  ACLStore.can("FeatureFlag:OptimizeReadReceipt");

export const isSendMessageOnShiftEnterEnabled = () =>
  ACLStore.can("FeatureFlag:SendMessageOnShiftEnter");

export const getIsUserChatActivityLogEnabled = () => {
  return ACLStore.can(USER_CHAT_ACTIVITY_LOG_CONFIG);
};

// This function blocks access to staff-only routes
export const isStaffPageBlocked = module => {
  const {
    permission,
    teacherPermission,
    rnpPermission,
    isCurriculumLevel,
  } = _.get(MESSAGING_V2_SECTIONS_CONFIG, module, {});

  if (!(permission || teacherPermission) && !rnpPermission) return false;

  const permissionValue = permission ? ACLStore.can(permission) : false;
  const teacherPermissionValue = teacherPermission
    ? ACLStore.can(teacherPermission)
    : false;

  const enabledByPermission = permissionValue || teacherPermissionValue;

  const messagingRnpEnabled = isMessagingRnpEnabled();

  let isAllowed = false;

  if (messagingRnpEnabled) {
    const userCurriculumPrograms = getUserCurriculumPrograms();

    const hasRnpAccess =
      teacherPermissionValue ||
      (isCurriculumLevel
        ? checkIfPermissionIsEnabledInAnyCurriculum({
            permission: rnpPermission,
            curriculumProgramIds: _.map(userCurriculumPrograms, "id"),
          })
        : ACLStorage.getPermissionValueByContext(rnpPermission, []));

    isAllowed = enabledByPermission && hasRnpAccess;
  } else {
    const isStaffRole = getIsAdminByRole() || teacherPermissionValue;
    isAllowed = enabledByPermission && isStaffRole;
  }

  return !isAllowed;
};

export const isMessagingRevempEnabled = () => {
  return ACLStore.can("FeatureFlag:MessagingV2UIRevemp");
};

export const isMessagingRevampV2Enabled = () =>
  isMessagingRevempEnabled() &&
  isMessagingGlobalHeaderRevampEnable() &&
  ACLStore.can("FeatureFlag:InClassMessaging");

const PAID_CONNECT_MODULE_PERMISSION = "FeatureFlag:IsPaidConnectModule";

const checkIsPaidConnectModuleInAdminPortal = _.memoize(() => {
  const state = store.getState();

  const curriculumProgramList = _.get(
    state,
    "platform.organizationCurriculumPrograms",
    []
  );

  const configurationQueryVariables = generateConfigurationQueryVariablesMemoized(
    {
      src: "ADMIN_PORTAL_HOME_PAGE",
      curriculumProgramList,
    }
  );

  const configurationResponse = getConfigurationsFromCacheV2(
    configurationQueryVariables
  );

  // configurationResponse is array of configurations check if some value condition is true

  const isSomePaidConnectModule = _.some(
    configurationResponse,
    curriculumConfig => {
      const configurations = _.get(curriculumConfig, "configurations", []);

      const paidCurriculumConfig = _.find(configurations, config =>
        _.isEqual(
          _.get(config, "configuration"),
          PAID_CONNECT_MODULE_PERMISSION
        )
      );

      const isPaidConnectCurriculumConfig = parseConfigurationValue(
        paidCurriculumConfig
      );

      return isPaidConnectCurriculumConfig;
    }
  );

  return isSomePaidConnectModule;
});

const checkIsPaidConnectModule = () => {
  const state = store.getState();

  const activeTab = _.get(state, "login.activeTab", "");
  const isFromAdminPage = activeTab === "admin";

  if (isFromAdminPage) return checkIsPaidConnectModuleInAdminPortal();

  return ACLStore.can(PAID_CONNECT_MODULE_PERMISSION);
};

export const isPaidConnectModule = () =>
  !isMessagingCurriculumWiseSplitEnabled() || checkIsPaidConnectModule();

export const isPaidConnectModuleForStudent = () => {
  if (getIsStudent()) {
    return isPaidConnectModule();
  }
  return true;
};

export const isPaidConnectModuleForStaff = () => {
  if (getIsStaff()) {
    return isPaidConnectModule();
  } else {
    return true;
  }
};

export const canShowChannel = () => {
  return isPaidConnectModule() || getPreExistingChannelCount() > 0;
};

export const canShowStaffAndStudentChatToStaff = () => {
  return (
    isPaidConnectModuleForStaff() ||
    getPreExistingStaffAndStudentChatCount() > 0
  );
};
export const canShowStaffAndStudentChatForStudent = () => {
  return (
    isPaidConnectModuleForStudent() ||
    getPreExistingStaffAndStudentChatCount() > 0 ||
    getPreExistingChannelCount() > 0
  );
};
export const isMessagingGlobalHeaderRevampEnable = () =>
  ACLStore.can("FeatureFlag:MessagingGlobalHeaderRevamp");

export const getIsPreviewChatInSummaryModalEnabled = () =>
  ACLStore.can("FeatureFlag:PreviewChatInSummarise");

export const OVERVIEW_ANALYTICS_PERMISSION =
  "FeatureFlag:MessagingV2OverviewAnalytics";
export const VOLUME_ANALYTICS_PERMISSION =
  "FeatureFlag:MessagingV2VolumeAnalytics";
export const FLAGGED_MESSAGE_PERMISSION =
  "FeatureFlag:MessagingFlaggedMessages";
export const SENTIMENT_ANALYTICS_PERMISSION =
  "FeatureFlag:MessagingV2SentimentModule";
export const MODULE_SETTINGS_PERMISSION =
  "FeatureFlag:MessagingRevampModuleSettings";

export const MESSAGING_SETTINGS_V2_PERMISSION =
  "FeatureFlag:MessagingSettingsV2";
export const STAFF_DIRECTORY_PERMISSION = "FeatureFlag:ConnectDepartments";

export const FLAGGED_MESSAGE_TEACHER_PERMISSION =
  "FeatureFlag:ConnectFlaggedForTeachers";
export const OVERVIEW_ANALYTICS_TEACHER_PERMISSION =
  "FeatureFlag:ConnectOverviewForTeachers";
export const VOLUME_ANALYTICS_TEACHER_PERMISSION =
  "FeatureFlag:ConnectAnalyticsForTeachers";

export const getStudentOrSelectedChildPrimaryGradeId = ({ childID }) => {
  const userType = getUserType();

  if (_.isEqual(userType, PARENT)) {
    const childrenYearGroupGrade = getChildrenYearGroupGradeFromCache({
      id: getUserId(),
      organizationId: getOrganizationId(),
    });

    const allChildren = _.get(childrenYearGroupGrade, "node.children", []);

    const child = _.find(allChildren, { id: childID });
    return _.get(child, "yearGroup.grade.id");
  }
  if (_.isEqual(userType, STUDENT)) {
    const userData = getPlatformUserDetailsFromCache({
      id: getUserId(),
      type: getUserEntityType(),
    });
    return _.get(userData, "yearGroup.grade.id");
  }
};

const getGradeLevelConfigurationsValue = () => {
  const state = store.getState();

  const childID = _.get(state, "login.userInfo.childID", "");

  const studentOrSelectedChildPrimaryGradeId = getStudentOrSelectedChildPrimaryGradeId(
    {
      childID,
    }
  );

  const variables = generateConfigurationQueryVariables({
    src: "GRADE_ONLY",
    configurations: MESSAGING_GRADE_LEVEL_CONFIGS,
    gradeId: studentOrSelectedChildPrimaryGradeId,
  });
  const configurationsResponse = getConfigurationQueryFromCache(variables);

  const configurations = _.get(
    configurationsResponse,
    "platform.configuration.0.configurations",
    []
  );

  const configurationsMap = _.reduce(
    configurations,
    (acc, configuration) => {
      const config = _.get(configuration, "configuration");
      acc[config] = parseConfigurationValue(configuration);
      return acc;
    },
    {}
  );

  return configurationsMap;
};

export const getGradeLevelConfigValue = config => {
  const configurationsMap = getGradeLevelConfigurationsValue();
  return _.get(configurationsMap, config);
};

export const isMessagingBlockingUserEnabled = type => {
  switch (type) {
    case STAFF:
      return ACLStore.can("FeatureFlag:MessagingV2BlockStaff");
    case STUDENT:
      return ACLStore.can("FeatureFlag:MessagingV2BlockStudent");
    case PARENT:
      return ACLStore.can("FeatureFlag:MessagingV2BlockFamily");
    default:
      return false;
  }
};

const getGradeLevelConfigValueAndDisabledGrades = config => {
  const variables = generateConfigurationQueryVariables({
    src: "ORGANIZATION_LEVEL",
    organizationId: getOrganizationId(),
    configurations: MESSAGING_MODULE_GRADE_LEVEL_CONFIG,
  });

  const configurationsResponse = getConfigurationQueryFromCache(variables);

  const configurations = _.get(
    configurationsResponse,
    "platform.configuration.0.configurations",
    []
  );

  const targetConfiguration = _.find(configurations, configuration =>
    _.isEqual(_.get(configuration, "configuration"), config)
  );

  if (!targetConfiguration) {
    return {
      value: false,
      disabledGradeIds: [],
    };
  }

  const value = parseConfigurationValue(targetConfiguration);

  const disabledGradeIds = _.chain(targetConfiguration)
    .get("disabledEntityGroups", [])
    .flatMap(group => _.get(group, "entities", []))
    .filter(entity => _.get(entity, "entityType") === "GRADE")
    .map(entity => _.get(entity, "entityId"))
    .uniq()
    .value();

  return {
    value,
    disabledGradeIds,
  };
};

export const isMessagingDisabledForStudent = gradeId => {
  const config = CONFIGURATION.MESSAGINGV2_FOR_STUDENT;

  const { value, disabledGradeIds } = getGradeLevelConfigValueAndDisabledGrades(
    config
  );

  if (!value) return true;

  return _.includes(disabledGradeIds, gradeId);
};

export const isMessagingDisabledForFamily = gradeIds => {
  const config = CONFIGURATION.MESSAGINGV2_FOR_FAMILY;

  const { value, disabledGradeIds } = getGradeLevelConfigValueAndDisabledGrades(
    config
  );

  if (!value) return true;

  return _.every(gradeIds, gradeId => _.includes(disabledGradeIds, gradeId));
};

export const isMessagingSettingsV2Enabled = () =>
  ACLStore.can(MESSAGING_SETTINGS_V2_PERMISSION);

export const isMessagingCurriculumWiseSplitEnabled = () =>
  ACLStore.can("FeatureFlag:ConnectCurriculumSplit");

export const showAudioRecordingConfigSetting = () =>
  ACLStore.can("FeatureFlag:ShowAudioRecorderConfigInConnectSettings");

export const showActionButtonInNotification = () =>
  ACLStore.can("FeatureFlag:ShowActionButtonInNotification");

export const isTeacherPermissionEnabled = () => {
  return (
    ACLStore.can(OVERVIEW_ANALYTICS_TEACHER_PERMISSION) ||
    ACLStore.can(VOLUME_ANALYTICS_TEACHER_PERMISSION) ||
    ACLStore.can(FLAGGED_MESSAGE_TEACHER_PERMISSION)
  );
};

export const MESSAGING_V2_SECTIONS_CONFIG = {
  [MESSAGING_SECTIONS.CHAT]: {
    id: MESSAGING_SECTIONS.CHAT,
    label: "common:chats",
    labelV2: "common:message_plural",
    route: "chat",
    Icon: CommentOutlined,
    ActiveIcon: ChatTextFilled,
    showBadge: true,
    badgeDataKey: "chatUnreadCount",
  },
  [MESSAGING_SECTIONS.CHANNELS]: {
    id: MESSAGING_SECTIONS.CHANNELS,
    label: "common:channels",
    route: "channels",
    Icon: HashtagOutlined,
    ActiveIcon: HashtagOutlined,
    showBadge: true,
    badgeDataKey: "channelUnreadCount",
  },
  [MESSAGING_SECTIONS.SEARCH]: {
    id: MESSAGING_SECTIONS.SEARCH,
    label: "common:search",
    route: "searchv2",
    Icon: SearchOutlined,
    ActiveIcon: SearchOutlined,
  },
  [MESSAGING_SECTIONS.SETTINGS]: {
    id: MESSAGING_SECTIONS.SETTINGS,
    label: "common:settings",
    route: "module-settings",
    Icon: SettingsOutlined,
    ActiveIcon: SettingsFilled,
    isRoute: true,
    permission: MODULE_SETTINGS_PERMISSION,
    rnpPermission: RNP_CAN_MANAGE_MESSAGING_SETTINGS,
  },
  [MESSAGING_SECTIONS.MONITOR]: {
    id: MESSAGING_SECTIONS.MONITOR,
    label: "common:overview",
    route: "monitor",
    Icon: EyeOutlined,
    ActiveIcon: EyeFilled,
    isRoute: true,
    checkIsPaid: true,
    isCurriculumLevel: true,
    teacherPermission: OVERVIEW_ANALYTICS_TEACHER_PERMISSION,
    permission: OVERVIEW_ANALYTICS_PERMISSION,
    rnpPermission: RNP_CAN_VIEW_ALL_CONVERSATIONS,
  },
  [MESSAGING_SECTIONS.ANALYSIS]: {
    id: MESSAGING_SECTIONS.ANALYSIS,
    label: "common:analytics",
    route: "volume-insights",
    Icon: AnalyticsOutlined,
    ActiveIcon: AnalyticsOutlined,
    isRoute: true,
    checkIsPaid: true,
    teacherPermission: VOLUME_ANALYTICS_TEACHER_PERMISSION,
    permission: VOLUME_ANALYTICS_PERMISSION,
    rnpPermission: RNP_CAN_VIEW_MESSAGING_INSIGHTS,
  },
  [MESSAGING_SECTIONS.FLAGGED]: {
    id: MESSAGING_SECTIONS.FLAGGED,
    label: "common:flagged",
    route: "flagged-messages",
    Icon: FlagOutlined,
    ActiveIcon: FlagFilled,
    isRoute: true,
    checkIsPaid: true,
    teacherPermission: FLAGGED_MESSAGE_TEACHER_PERMISSION,
    permission: FLAGGED_MESSAGE_PERMISSION,
    rnpPermission: RNP_CAN_VIEW_FLAGGED_MESSAGES,
  },
  [MESSAGING_SECTIONS.SENTIMENT]: {
    id: MESSAGING_SECTIONS.SENTIMENT,
    label: "common:sentiment",
    route: "sentiment-insights",
    Icon: SmileySatisfiedEyesOutlined,
    ActiveIcon: SmileySatisfiedEyesFilled,
    isRoute: true,
    checkIsPaid: true,
    permission: SENTIMENT_ANALYTICS_PERMISSION,
  },
  [MESSAGING_SECTIONS.DIRECTORY]: {
    id: MESSAGING_SECTIONS.DIRECTORY,
    label: "common:school_directory",
    route: "staff-directory",
    Icon: SpiralBookLinesOutlined,
    ActiveIcon: SpiralBookLinesOutlined,
    isRoute: true,
    checkIsPaid: true,
    checkIsAdmin: true,
    isHidden: () => !isMessagingV2ChannelEnabled(),
    permission: STAFF_DIRECTORY_PERMISSION,
  },
};

export const SEARCH_SCREEN_TABS_CONFIG = {
  [SEARCH_ALL_SCREEN_TABS_CONSTANTS.MESSAGES]: {
    value: SEARCH_ALL_SCREEN_TABS_CONSTANTS.MESSAGES,
    label: "common:message_plural",
    route: "messages",
    countKey: "messages",
  },
  [SEARCH_ALL_SCREEN_TABS_CONSTANTS.MEMBERS]: {
    value: SEARCH_ALL_SCREEN_TABS_CONSTANTS.MEMBERS,
    label: "common:members",
    route: "members",
    countKey: "messageV2Users",
  },
  [SEARCH_ALL_SCREEN_TABS_CONSTANTS.CHANNELS]: {
    value: SEARCH_ALL_SCREEN_TABS_CONSTANTS.CHANNELS,
    label: "common:channels",
    route: "channels",
    countKey: "chats",
  },
  [SEARCH_ALL_SCREEN_TABS_CONSTANTS.FILES]: {
    value: SEARCH_ALL_SCREEN_TABS_CONSTANTS.FILES,
    label: "common:file_plural",
    route: "files",
    countKey: "attachments",
  },
};

export const MESSAGING_V2_LEFT_PANE_SECTIONS = {
  chatSection: [
    MESSAGING_SECTIONS.CHAT,
    MESSAGING_SECTIONS.CHANNELS,
    MESSAGING_SECTIONS.MONITOR,
  ],
  analysis: [
    MESSAGING_SECTIONS.FLAGGED,
    MESSAGING_SECTIONS.SENTIMENT,
    MESSAGING_SECTIONS.ANALYSIS,
    MESSAGING_SECTIONS.DIRECTORY,
  ],
  settings: [MESSAGING_SECTIONS.SETTINGS],
};

export const LEFT_PANE_SECTIONS_KEY = _.keys(MESSAGING_V2_LEFT_PANE_SECTIONS);

export const getUnreadChatsCountQueryVariables = () => {
  const isRevampV2Enabled = isMessagingRevampV2Enabled();
  const isChannelEnabled = isMessagingV2ChannelEnabled();
  return {
    organizationId: getOrganizationId(),
    inputChat: {
      isRead: false,
      type: [CHAT_TYPE_BE.CHAT_PERSONAL],
    },
    inputChannel: {
      isRead: false,
      type: CHANNEL_TYPES_LIST,
    },
    inputAll: {
      isRead: false,
      type: isChannelEnabled ? [] : [CHAT_TYPE_BE.CHAT_PERSONAL],
    },
    skipChatCount: isRevampV2Enabled,
    skipChannelCount: !isChannelEnabled || isRevampV2Enabled,
    portalType: "PLANNER",
  };
};

export const getTotalChatAndChannelCountQueryVariables = () => {
  return {
    organizationId: getOrganizationId(),
    inputStaffAndStudentChat: {
      type: [CHAT_TYPE_BE.CHAT_PERSONAL],
      userType: [STAFF, STUDENT],
    },
    inputForTotalChannel: {
      type: [
        CHAT_TYPE_BE.CHANNEL_CUSTOM,
        CHAT_TYPE_BE.CHANNEL_FAMILY,
        CHAT_TYPE_BE.CHANNEL_SYSTEM_MANAGED,
      ],
    },
  };
};

export const getPreExistingChannelCount = () => {
  const chatResult = getTotalChatAndChannelCountQueryFromCache(
    getTotalChatAndChannelCountQueryVariables()
  );
  return _.get(chatResult, "node.chats.totalChannelCount", 0);
};
export const getPreExistingStaffAndStudentChatCount = () => {
  const chatResult = getTotalChatAndChannelCountQueryFromCache(
    getTotalChatAndChannelCountQueryVariables()
  );
  return _.get(chatResult, "node.chats.chatStaffAndStudentCount", 0);
};

export const SEARCH_ALL_SCREEN_TABS = [
  SEARCH_ALL_SCREEN_TABS_CONSTANTS.MEMBERS,
  SEARCH_ALL_SCREEN_TABS_CONSTANTS.MESSAGES,
  SEARCH_ALL_SCREEN_TABS_CONSTANTS.FILES,
  SEARCH_ALL_SCREEN_TABS_CONSTANTS.CHANNELS,
];

export const getSearchAllScreenTabs = () => {
  if (!isMessagingV2ChannelEnabled()) {
    return _.filter(
      SEARCH_ALL_SCREEN_TABS,
      item => item !== SEARCH_ALL_SCREEN_TABS_CONSTANTS.CHANNELS
    );
  }
  return SEARCH_ALL_SCREEN_TABS;
};

export const PERSONAL_CHAT_TYPE = {
  STAFF_WITH_STAFF: "STAFF_WITH_STAFF",
  STAFF_WITH_FAMILY: "STAFF_WITH_FAMILY",
  STAFF_WITH_STUDENT: "STAFF_WITH_STUDENT",
};

const gePermissionForModuleSetting = () => {
  const state = store.getState();

  const childID = _.get(state, "login.userInfo.childID", "");

  const studentOrSelectedChildPrimaryGradeId = getStudentOrSelectedChildPrimaryGradeId(
    {
      childID,
    }
  );
  const userType = getUserType();

  return getSettingValue({
    name: MESSAGING_USER_TYPE_CONFIG[userType],
    gradeId: studentOrSelectedChildPrimaryGradeId,
  });
};

export const isMessagingV2Enabled = () => {
  const userType = getUserType();

  if (_.isEqual(userType, STAFF) && isMessagingRnpEnabled()) {
    return (
      ACLStore.can("FeatureFlag:MessagingV2") &&
      ACLStorage.getModuleSettingsValueByContext(
        RNP_CAN_VIEW_MESSAGING_MODULE,
        []
      )
    );
  }
  if (getIsAdminByRole()) return ACLStore.can("FeatureFlag:MessagingV2");
  const configValue = ACLStore.can(
    ["FeatureFlag:MessagingV2", MESSAGING_USER_TYPE_CONFIG[userType]],
    "all"
  );

  const manageModuleSettingEnabled = getIsModuleSettingsV2Enabled();
  const messagingV2Enabled = isMessagingSettingsV2Enabled();

  if (messagingV2Enabled) {
    if (manageModuleSettingEnabled) {
      return gePermissionForModuleSetting();
    }

    return (
      configValue &&
      getGradeLevelConfigValue(MESSAGING_USER_TYPE_CONFIG[userType])
    );
  }

  return manageModuleSettingEnabled
    ? gePermissionForModuleSetting()
    : configValue;
};

export const MESSAGING_V2_WIDGET_WRAPPER_ID = "__messaging-v2-widget-wrapper__";

export const isMessagingV2HelpEnabled = () =>
  ACLStore.can("FeatureFlag:ShowHelpInMessagingV2");

export const isOverviewAiFeatureEnabled = () =>
  ACLStore.can("FeatureFlag:MessagingV2OverviewAIFeatures");

export const isSentimentScoreFeatureHidden = () =>
  ACLStore.can("FeatureFlag:HideSentiementScoreInMessagingV2");

export const isAddMembersV3Enabled = () =>
  ACLStore.can("FeatureFlag:ChannelAddMembersV3");

export const isConnectOptimisticAblyCallEnabled = () =>
  ACLStore.can("FeatureFlag:ConnectOptimisticAblyCall");

export const isChatToChannelEnabled = () =>
  isMessagingV2ChannelEnabled() &&
  isCreateAndManageOwnChannelEnabled() &&
  ACLStore.can("FeatureFlag:ChatToChannel");

export const isMessagingAudioRecordingEnabled = () =>
  ACLStore.can("Settings:AllowAudioRecordingInConnect");

export const DURATION_TYPES = {
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
};

export const isCreateChatsAndChannelsEnableForAll = () => {
  const userCurriculumPrograms = getUserCurriculumPrograms();
  const curriculumProgramIds = _.map(userCurriculumPrograms, "id");

  return checkIfPermissionIsEnabledInAnyCurriculum({
    permission: RNP_CAN_CREATE_AND_MANAGE_CHATS_AND_CHANNELS,
    curriculumProgramIds,
  });
};

export const getChatsAndChannelEnabledCurriculum = () => {
  const userCurriculumPrograms = getUserCurriculumPrograms();
  const curriculumProgramIds = _.map(userCurriculumPrograms, "id");
  return _.filter(curriculumProgramIds, curriculumProgramId => {
    return checkIfPermissionIsEnabledInAnyCurriculum({
      permission: RNP_CAN_CREATE_AND_MANAGE_CHATS_AND_CHANNELS,
      curriculumProgramIds: [curriculumProgramId],
    });
  });
};

export const getChatsAndChannelEnabledCurriculumPrograms = () => {
  const userCurriculumPrograms = getUserCurriculumPrograms();
  return _.filter(userCurriculumPrograms, program => {
    return checkIfPermissionIsEnabledInAnyCurriculum({
      permission: RNP_CAN_CREATE_AND_MANAGE_CHATS_AND_CHANNELS,
      curriculumProgramIds: [program.id],
    });
  });
};

export const isCreateChatAndChannelEnableForClass = () => {
  const data = getStaffRnpFilterCoursesCountFromCache({
    userId: getUserId(),
    filters: {
      fetchOnlyMappedCourses: false,
      controlParameters: [
        RNP_CAN_CREATE_AND_MANAGE_CHATS_AND_CHANNELS_FOR_CLASS,
      ],
    },
  });
  return !!_.get(data, "coursesV2.totalCount", 0);
};

export const isModifyMessageEnabled = () => {
  const state = store.getState();
  const userType = getUserType(state);

  if (_.isEqual(userType, STAFF) && isMessagingRnpEnabled()) {
    return ACLStorage.getPermissionValueByContext(
      RNP_CAN_MODIFY_THEIR_MESSAGE,
      []
    );
  }
  if (getIsAdminByRole()) return true;
  const configValue = ACLStore.can(MODIFY_MESSAGE_CONFIG[userType]);

  return isMessagingSettingsV2Enabled()
    ? configValue && getGradeLevelConfigValue(MODIFY_MESSAGE_CONFIG[userType])
    : configValue;
};

export const isMessagingReadReceiptEnabled = () =>
  ACLStore.can("FeatureFlag:ConnectReadReceipt");

export const canAdminDeleteMessage = () =>
  ACLStore.can("FeatureFlag:ConnectAdminCanDeleteMessage");

export const canStaffDeleteMessage = () =>
  ACLStore.can("Setting:ConnectStaffCanDeleteMessage");

export const isMessagingV2ChannelEnabled = () =>
  ACLStore.can("FeatureFlag:ShowChannelsInConnect");

export const isInitiateMessageEnabled = () => {
  const state = store.getState();
  const userType = getUserType(state);

  if (_.isEqual(userType, STAFF) && isMessagingRnpEnabled()) {
    return (
      isCreateChatsAndChannelsEnableForAll() ||
      isCreateChatAndChannelEnableForClass()
    );
  }

  if (_.isEqual(userType, STAFF)) return true;
  const configValue = ACLStore.can(INITIATE_CONVERSATION_CONFIG[userType]);

  if (_.isEqual(userType, STUDENT) && !isPaidConnectModule()) return false;
  return isMessagingSettingsV2Enabled()
    ? configValue &&
        getGradeLevelConfigValue(INITIATE_CONVERSATION_CONFIG[userType])
    : configValue;
};

export const isCreateAndManageOwnChannelEnabled = () => {
  if (!isPaidConnectModule()) return false;

  const state = store.getState();
  const userType = getUserType(state);

  if (_.isEqual(userType, STAFF) && isMessagingRnpEnabled()) {
    return (
      isCreateChatsAndChannelsEnableForAll() ||
      isCreateChatAndChannelEnableForClass()
    );
  }

  if (!_.isEqual(userType, STAFF)) return false;
  if (getIsAdminByRole()) return true;

  return ACLStore.can("Setting:CanStaffCreateAndManageChannel");
};

export const isManageChannelsEnabledForNonCreator = () => {
  if (!isPaidConnectModule()) return false;
  const state = store.getState();
  const userType = getUserType(state);

  if (_.isEqual(userType, STAFF) && isMessagingRnpEnabled()) {
    return ACLStorage.getPermissionValueByContext(
      RNP_CAN_MANAGE_CHANNELS_THEY_ARE_ADDED_TO,
      []
    );
  }

  if (!_.isEqual(userType, STAFF)) return false;
  if (getIsAdminByRole()) return true;
  return ACLStore.can("Setting:CanStaffChannelMemberManageChannel");
};

export const getIsAIGenerateEnabled = (state = store.getState()) => {
  if (!isPaidConnectModule()) return false;
  const isStaff = getIsStaff(state);
  if (!isStaff) return false;
  if (!isMessagingRevempEnabled()) return false;
  return ACLStore.can(AI_GENERATE_PERMISSION);
};

export const getPublicChannelLink = ({ chatId }) => {
  const metadata = {
    chatId,
  };
  const metadataString = JSON.stringify(metadata);
  const encodedMetadata = encodeURIComponent(metadataString);

  return `${window.location.origin}/?type=MESSAGING&metadata=${encodedMetadata}`;
};

export const getIsAIDebugModeEnabled = () =>
  ACLStore.can("IdentityAccess:EnableAIDebugMode") ||
  ACLStore.can("Common:EnableAIDebugMode");

export const isMessagingV2InputEnabled = () =>
  isMessagingRevempEnabled() && ACLStore.can("FeatureFlag:MessagingAIInputV2");

export const getIsAISummariseEnabled = (state = store.getState()) => {
  if (!isPaidConnectModule()) return false;
  const isStaff = getIsStaff(state);
  if (!isStaff) return false;
  if (!isMessagingRevempEnabled()) return false;
  return ACLStore.can(AI_SUMMARISE_PERMISSION);
};

export const isMessagingPollEnabled = () =>
  ACLStore.can("FeatureFlag:ConnectPoll");

export const isMessagingFormEnabled = () =>
  ACLStore.can("FeatureFlag:ConnectForms");

export const getChatSessionKey = ({
  chatId,
  organizationId = getOrganizationId(),
}) => `${chatId}_${organizationId}`;

export const getIsLocalMessage = messageId => _.startsWith(messageId, "NEW_");

export const PAGINATION_LIMITS = {
  // to handle 4k screens safely
  MESSAGES_FEED: 50,
  THREAD_LIST: 30,
  FETCH_MORE_MESSAGES: 30,
  SEARCH_PAGE_USER_LIMIT: 10,
};

export const CHAT_TYPE_ENUM = {
  CHAT_PERSONAL: "CHAT_PERSONAL",
  CHANNEL_SYSTEM_MANAGED: "CHANNEL_SYSTEM_MANAGED",
  CHANNEL_CUSTOM: "CHANNEL_CUSTOM",
  CHANNEL_FAMILY: "CHANNEL_FAMILY",
  CHANNEL_PUBLIC: "CHANNEL_PUBLIC",
  CHANNEL_DEPARTMENT: "CHANNEL_DEPARTMENT",
};

export const KEYBOARD_SHORTCUT = {
  SHIFT_ENTER: { code: "Enter", shiftKey: true },
};

export const CHANNEL_ACTIVITY_TYPES = {
  USER_ADD: "USER_ADD",
  USER_REMOVE: "USER_REMOVE",
  LABEL_CHANGE: "LABEL_CHANGE",
  DESCRIPTION_CHANGE: "DESCRIPTION_CHANGE",
  BANNER_MESSAGE_CHANGE: "BANNER_MESSAGE_CHANGE",
  MESSAGE_MOVE_TO: "MESSAGE_MOVE_TO",
  MESSAGE_MOVE_FROM: "MESSAGE_MOVE_FROM",
  TYPE_CHANGE: "TYPE_CHANGE",
};

export const OVERVIEW_AND_SETTING_CHANNEL_TABS_CONFIG = {
  [OVERVIEW_AND_SETTING_CHANNEL_TABS_CONSTANTS.ABOUT]: {
    value: OVERVIEW_AND_SETTING_CHANNEL_TABS_CONSTANTS.ABOUT,
    label: "common:about",
    route: "about",
    countKey: "about",
    visibleChatTypes: [
      CHAT_TYPE_ENUM.CHANNEL_CUSTOM,
      CHAT_TYPE_ENUM.CHANNEL_PUBLIC,
      CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT,
    ],
  },
  [OVERVIEW_AND_SETTING_CHANNEL_TABS_CONSTANTS.MEMBERS]: {
    value: OVERVIEW_AND_SETTING_CHANNEL_TABS_CONSTANTS.MEMBERS,
    label: "common:members",
    route: "members",
    countKey: "messageV2Users",
    visibleChatTypes: [
      CHAT_TYPE_ENUM.CHANNEL_CUSTOM,
      CHAT_TYPE_ENUM.CHANNEL_PUBLIC,
      CHAT_TYPE_ENUM.CHANNEL_SYSTEM_MANAGED,
      CHAT_TYPE_ENUM.CHANNEL_FAMILY,
      CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT,
    ],
  },
  [OVERVIEW_AND_SETTING_CHANNEL_TABS_CONSTANTS.SETTINGS]: {
    value: OVERVIEW_AND_SETTING_CHANNEL_TABS_CONSTANTS.SETTINGS,
    label: "common:settings",
    route: "settings",
    countKey: "settings",
    visibleChatTypes: [
      CHAT_TYPE_ENUM.CHANNEL_CUSTOM,
      CHAT_TYPE_ENUM.CHANNEL_SYSTEM_MANAGED,
      CHAT_TYPE_ENUM.CHANNEL_PUBLIC,
      CHAT_TYPE_ENUM.CHANNEL_FAMILY,
      CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT,
    ],
  },
};

export const areDatesSameDay = (date1, date2) => {
  const date1Obj = moment(date1);
  return date1Obj.isSame(date2, "day");
};

// undefined granularity means comparing by milliseconds
export const areMomentsSame = ({ date1, date2, granularity = undefined }) =>
  moment(date1).isSame(date2, granularity);

export const getMessageDOMId = message =>
  `Conversation-${message.type}-${message.id}`;

export const CHAT_TYPES = {
  CHAT_PERSONAL: "CHAT_PERSONAL",
};

export const CHANNEL_TYPES = {
  CHANNEL_CUSTOM: "CHANNEL_CUSTOM",
  CHANNEL_FAMILY: "CHANNEL_FAMILY",
  CHANNEL_SYSTEM_MANAGED: "CHANNEL_SYSTEM_MANAGED",
  CHANNEL_PUBLIC: "CHANNEL_PUBLIC",
  CHANNEL_DEPARTMENT: "CHANNEL_DEPARTMENT",
};

export const CHANNEL_TYPES_LIST = [
  CHANNEL_TYPES.CHANNEL_SYSTEM_MANAGED,
  CHANNEL_TYPES.CHANNEL_CUSTOM,
  CHANNEL_TYPES.CHANNEL_PUBLIC,
  CHANNEL_TYPES.CHANNEL_FAMILY,
  CHANNEL_TYPES.CHANNEL_DEPARTMENT,
];

export const FORWARD_MESSAGE_VISIBILITY_CONFIG = {
  CHANNELS: {
    key: "CHANNELS",
    priority: 1,
    dataKey: "channelListParams",
    header: "common:channels",
  },
  USERS: {
    key: "USERS",
    priority: 2,
    dataKey: "membersParams",
    header: "common:chats",
  },
  EMPTY: {
    key: "EMPTY",
    priority: 0,
  },
};

export const CHAT_STATUS_ENUM = {
  ALL: "ALL",
  INITIATED: "INITIATED",
  NOT_INITIATED: "NOT_INITIATED",
};

export const areMessagesEqual = (message1, message2) => {
  if (!message1 || !message2) {
    return false;
  }
  return isIdEqual(message1.id, message2.id) && message1.type === message2.type;
};

export const getFormattedNameForUserType = ({
  user,
  orderBy,
  isFormattedNameV2 = false,
  defaultStudentNameOrderPreference,
}) => {
  if (user.type === STUDENT) {
    return getFormattedUserName({
      user,
      orderBy,
    });
  }
  return getFormattedUserName({ user });
};

export const getPersonalChatLabel = ({
  users,
  defaultNameSortPreference,
  defaultStudentNameOrderPreference,
}) => {
  const [user1Name, user2Name] = _.map(users, user =>
    getFormattedNameForUserType({
      user,
      orderBy: defaultNameSortPreference,
      defaultStudentNameOrderPreference,
      isFormattedNameV2: true,
    })
  );
  return `${user1Name} <> ${user2Name}`;
};

export const DATE_FORMATS = {
  DATE_MESSAGE: "ddd, Do MMMM YYYY",
  SENT_MESSAGE: "h:mm a",
};

export const ATTACHMENT_TYPES = {
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  FILE: "FILE",
  AUDIO: "AUDIO",
  LINK: "LINK",
};

export const getSubText = ({
  messagedUserRole,
  messagedUserObj,
  t,
  defaultStudentNameSortPreference = getDefaultOrderBy({ type: STUDENT }),
  showStudentId = false,
  studentId,
}) => {
  switch (messagedUserRole) {
    case STUDENT: {
      const grade = _.get(messagedUserObj, "yearGroup.grade.name");
      const curriculumLabel = _.get(
        messagedUserObj,
        "yearGroup.curriculumProgram.label"
      );
      let subText;
      if (showStudentId && grade) {
        subText = t("common:student_id_grade", {
          id: studentId,
          grade,
        });
      } else if (showStudentId) {
        subText = t("common:student_id_with_divider", { id: studentId });
      } else if (grade) {
        subText = `${t("common:student")} • ${grade}`;
      } else {
        subText = t("common:student");
      }
      if (curriculumLabel) {
        subText = `${subText} • ${curriculumLabel}`;
      }
      return subText;
    }

    case STAFF: {
      const staffSubText = messagedUserObj.displayRole;
      const staffCurriculumLabels = _.map(
        messagedUserObj.curriculumPrograms,
        "label"
      );
      if (!_.isEmpty(staffCurriculumLabels)) {
        const firstLabel = _.first(staffCurriculumLabels);
        const remainingCount = _.size(staffCurriculumLabels) - 1;
        const curriculumText =
          remainingCount > 0
            ? `${firstLabel} ${t("common:plus_more_with_count", {
                count: remainingCount,
              })}`
            : firstLabel;
        return staffSubText
          ? `${staffSubText} • ${curriculumText}`
          : curriculumText;
      }
      return staffSubText;
    }

    case PARENT: {
      const childrenCount = _.size(messagedUserObj.children);
      if (childrenCount === 1) {
        return t("common:family_member_of_label", {
          label: getFormattedUserName({
            user: _.first(messagedUserObj.children),
            type: STUDENT,
            orderBy: defaultStudentNameSortPreference,
          }),
        });
      } else if (childrenCount > 1) {
        return t("common:family_member_of_label_and_count", {
          label: getFormattedUserName({
            user: _.first(messagedUserObj.children),
            type: STUDENT,
            orderBy: defaultStudentNameSortPreference,
          }),
          count: childrenCount - 1,
        });
      }

      return t("common:family_of_count_student_other", {
        count: 0,
      });
    }
    default:
      break;
  }
};

export const isSameDay = (date1, date2) => {
  return moment(date1).isSame(date2, "day");
};

export const getColorForSentimentScore = score => {
  if (score === null) return colors.textSubtle; // N/A
  if (score < -0.25) return colors.textCritical; // Negative
  if (score < 0.25) return colors.yellow500; // Neutral
  return colors.textOnSuccess; // Positive
};

export const getChatContainer = chatId =>
  document.getElementById(`chat-scroll-container-${chatId}`);

export const isChatNearBottom = ({ chatId, threshold = 60 }) => {
  const containerElement = getChatContainer(chatId);
  if (!containerElement) return false;

  return (
    Math.abs(
      containerElement.scrollHeight -
        containerElement.scrollTop -
        containerElement.clientHeight
    ) < threshold
  );
};

export const scrollOnlyIfNearBottom = ({
  threshold = 60,
  chatId,
  behavior = "smooth",
  afterCalculationCb = () => {},
} = {}) => {
  const containerElement = getChatContainer(chatId);
  if (!containerElement) return;

  const isNearBottom = isChatNearBottom({ chatId, threshold });

  afterCalculationCb(isNearBottom);
  if (!isNearBottom) return;
  setTimeout(() => {
    containerElement.scrollTo({
      top: containerElement.scrollHeight,
      behavior,
    });
  });
};

const isElementVisibleInContainer = ({
  element,
  container,
  topThreshold = 16,
}) => {
  const { offsetTop, offsetHeight } = element;
  const { offsetTop: containerOffsetTop, scrollTop, clientHeight } = container;

  // Calculate the adjusted scrollTop to account for the container's
  // offset from the top of it's parentElement
  const adjustedContainerScrollTop = scrollTop + containerOffsetTop;
  const elementOffsetTopWithThreshold = offsetTop - topThreshold;

  const elementTopVisible =
    elementOffsetTopWithThreshold >= adjustedContainerScrollTop;

  const elementBottomVisible =
    offsetTop + offsetHeight <= clientHeight + adjustedContainerScrollTop;

  return elementTopVisible && elementBottomVisible;
};

const subscribeToScrollEnd = ({ element, callback }) => {
  // debounce would help in detecting the scroll end(when user stops scrolling)
  const callbackWrapper = _.debounce(callback, 150);
  element.addEventListener("scroll", callbackWrapper);

  return () => {
    callbackWrapper.cancel();
    element.removeEventListener("scroll", callbackWrapper);
  };
};

export const scrollToMessageIfPresent = ({
  chatId,
  messageId,
  behavior = "instant",
  scrollOnlyIfNotVisible = true,
  afterScrollCb,
}) => {
  const organizationId = getOrganizationId();
  const { type } = readMessageFromCache({ messageId, organizationId });
  const containerElement = getChatContainer(chatId);

  if (!containerElement) return false;

  // TODO: would need to update if we start to use Virtualization
  const messageElement = document.getElementById(
    getMessageDOMId({ id: messageId, type })
  );

  if (!messageElement) return false;

  const topThreshold = 16;
  const isMessageVisibleInViewport = isElementVisibleInContainer({
    element: messageElement,
    container: containerElement,
    topThreshold,
  });

  const elementOffsetTopWithThreshold = messageElement.offsetTop - topThreshold;

  // message already visible, and flag is set to scroll only if not visible
  // so no need to scroll, just return true
  if (scrollOnlyIfNotVisible && isMessageVisibleInViewport) {
    if (_.isFunction(afterScrollCb)) afterScrollCb();
    return true;
  }

  const top = elementOffsetTopWithThreshold - containerElement.offsetTop;

  if (_.isFunction(afterScrollCb)) {
    const unsubscribe = subscribeToScrollEnd({
      element: containerElement,
      callback: () => {
        afterScrollCb();
        unsubscribe();
      },
    });
  }

  containerElement.scrollTo({ top, behavior });
  return true;
};

export const scrollToBottomInChat = ({ chatId, scrollInNextTick = false }) => {
  const scrollElement = getChatContainer(chatId);
  if (!scrollElement) return;

  if (scrollInNextTick) {
    setTimeout(() => {
      scrollElement?.scrollTo?.({ top: scrollElement.scrollHeight });
    });
  } else {
    scrollElement.scrollTo({ top: scrollElement.scrollHeight });
  }
};

export const ORDERED_USER_TYPES = [STAFF, STUDENT, PARENT];
export const sortUserTypes = userTypes =>
  _.sortBy(userTypes, type => _.indexOf(ORDERED_USER_TYPES, type));

export const getChatAndChannelListQueryVariables = (
  filterState,
  input = {}
) => {
  const state = store.getState();
  const messagingState = _.get(state, "messagingV2", {});

  const selectedCourseId = _.get(
    state,
    "teacher.selected_class.selected_course"
  );

  const finalFilterState = filterState
    ? filterState
    : _.get(messagingState, "messageRevampV2FilterState", {});

  const threadFilter = _.get(
    finalFilterState,
    "threadFilter",
    MESSAGING_FILTERS_CONSTANTS.ALL
  );

  const searchFilter = _.get(finalFilterState, "searchFilter", "");

  const inputFilter = {
    first: input.first || PAGINATION_LIMITS.THREAD_LIST,
  };

  const isChannelEnabled = isMessagingV2ChannelEnabled();

  if (_.isEmpty(searchFilter)) {
    switch (threadFilter) {
      case MESSAGING_FILTERS_CONSTANTS.UNREAD:
        inputFilter.isRead = false;
        break;
      case MESSAGING_FILTERS_CONSTANTS.STAFF:
        inputFilter.userType = [STAFF];
        break;
      case MESSAGING_FILTERS_CONSTANTS.STUDENT:
        inputFilter.userType = [STUDENT];

        if (selectedCourseId) {
          inputFilter.excludeClassChannelByCourseIds = [selectedCourseId];
        }
        break;
      case MESSAGING_FILTERS_CONSTANTS.FAMILY:
        inputFilter.userType = [PARENT];
        break;

      case MESSAGING_FILTERS_CONSTANTS.PUBLIC_CHANNEL:
        inputFilter.type = [CHAT_TYPE_BE.CHANNEL_PUBLIC];
        break;

      case MESSAGING_FILTERS_CONSTANTS.DEPARTMENT_CHANNEL:
        inputFilter.type = [CHAT_TYPE_BE.CHANNEL_DEPARTMENT];
        break;
    }

    if (
      _.isEmpty(inputFilter.userType) &&
      _.isEmpty(inputFilter.isRead) &&
      selectedCourseId
    ) {
      inputFilter.excludeClassChannelByCourseIds = [selectedCourseId];
    }
  } else {
    inputFilter.search = {
      text: searchFilter,
    };
  }

  if (!isChannelEnabled) {
    inputFilter.type = [CHAT_TYPE_BE.CHAT_PERSONAL];
  }

  return {
    organizationId: getOrganizationId(),
    input: inputFilter,
    portalType: "PLANNER",
  };
};

export const getChatListQueryVariables = ({
  userType = [],
  input = {},
} = {}) => {
  const defaultInputFilter = {
    userType: _.isEmpty(userType) ? ORDERED_USER_TYPES : userType,
  };

  const inputFilter = {
    ...(_.isEmpty(input) ? defaultInputFilter : input),
    type: [CHAT_TYPE_BE.CHAT_PERSONAL],
    first: input.first || PAGINATION_LIMITS.THREAD_LIST,
  };

  if (_.isEmpty(inputFilter.userType)) {
    inputFilter.userType = ORDERED_USER_TYPES;
  }

  // order the user types to use cached results for same set of ordered user types
  inputFilter.userType = sortUserTypes([...inputFilter.userType]);

  return {
    organizationId: getOrganizationId(),
    input: inputFilter,
  };
};

export const getChatChannelQueryVariables = ({ userType = [], input = {} }) => {
  const defaultInputFilter = {
    userType: _.isEmpty(userType) ? ORDERED_USER_TYPES : userType,
  };

  const isChannelEnabled = isMessagingV2ChannelEnabled();

  const inputFilter = {
    ...(_.isEmpty(input) ? defaultInputFilter : input),
    type: isChannelEnabled ? [] : [CHAT_TYPE_BE.CHAT_PERSONAL],
    first: input.first ? input.first : PAGINATION_LIMITS.SEARCH_PAGE_USER_LIMIT,
  };

  if (_.isEmpty(inputFilter.userType)) {
    inputFilter.userType = ORDERED_USER_TYPES;
  }

  // order the user types to use cached results for same set of ordered user types
  inputFilter.userType = sortUserTypes([...inputFilter.userType]);

  return {
    organizationId: getOrganizationId(),
    input: inputFilter,
  };
};

const getStudentChannels = channels =>
  _.filter(channels, item => item !== CHANNEL_TYPES.CHANNEL_FAMILY);

const getFamilyChannels = channels =>
  _.filter(channels, item => item !== CHANNEL_TYPES.CHANNEL_SYSTEM_MANAGED);

const filterChannelsByUserType = {
  [STUDENT]: getStudentChannels,
  [PARENT]: getFamilyChannels,
  [STAFF]: channels => [...channels],
};

export const USER_SUPPORTED_CHANNELS = {
  [STAFF]: CHANNEL_TYPES_LIST,
  [STUDENT]: getStudentChannels(CHANNEL_TYPES_LIST),
  [PARENT]: getFamilyChannels(CHANNEL_TYPES_LIST),
};

export const sortChannelTypes = channelTypes =>
  _.sortBy(channelTypes, type => _.indexOf(CHANNEL_TYPES_LIST, type));

export const getChannelListQueryVariables = ({
  channelTypes = [],
  input,
  searchText,
} = {}) => {
  const state = store.getState();
  const loggedInUserType = getUserType(state);

  const defaultInputFilter = {
    type: _.isEmpty(channelTypes) ? CHANNEL_TYPES_LIST : channelTypes,
    search: { text: searchText },
  };

  const inputFilter = {
    ...(_.isEmpty(input) ? defaultInputFilter : input),
    first: input?.first ?? PAGINATION_LIMITS.THREAD_LIST,
  };

  if (_.isEmpty(inputFilter.type)) {
    inputFilter.type = CHANNEL_TYPES_LIST;
  }

  const getFilteredChannels = filterChannelsByUserType[loggedInUserType];
  // order the channel types to use cached results for same set of ordered channel types
  inputFilter.type = sortChannelTypes(getFilteredChannels(inputFilter.type));

  return {
    input: inputFilter,
    organizationId: getOrganizationId(),
  };
};

export const getChatDetailsQueryVariables = ({ chatId, userId }) => {
  return {
    id: chatId,
    userId,
    organizationId: getOrganizationId(),
  };
};

const getTimeSinceV2Text = (date, t) => {
  const now = moment(new Date());
  const momentDate = moment(date);
  const diffInHours = now.diff(momentDate, "hours");
  const diffInDays = now.diff(momentDate, "days");
  const isSameYear = now.isSame(momentDate, "year");

  if (diffInHours >= 24) {
    if (diffInHours <= 48) {
      return t("common:yesterday");
    }

    if (diffInDays <= 7) {
      return momentDate.format("dddd");
    }

    if (isSameYear) {
      return momentDate.format("Do MMM");
    }

    return momentDate.format("Do MMM, YYYY");
  } else {
    if (diffInHours < 1) {
      const diffInMin = moment().diff(date, "minutes");
      if (diffInMin < 1) {
        return t("common:now_uppercase");
      }
      return t("common:time_in_mins", { time: diffInMin });
    }
    return moment(date).format("h:mm a");
  }
};

export const getMessageTimeSinceText = (date, t) => {
  if (isMessagingRevempEnabled()) {
    return getTimeSinceV2Text(date, t);
  }

  return getTimeSince(date, t);
};

export const getUserReaction = ({
  allReactions,
  userId,
  comparatorKey = "uid", // "uid" or "unified"
  comparatorValue,
}) => {
  return _.find(
    allReactions,
    reaction =>
      _.isEqual(_.get(reaction, comparatorKey), comparatorValue) &&
      isIdEqual(_.get(reaction, "createdBy.id"), userId)
  );
};

export const getInitialDraftData = () => ({
  parentMessage: {},
  attachments: [],
  label: "",
  id: generateRandomId(),
  isEditMode: false,
});

export const addAttachmentsInDraftState = ({ draft, attachments }) => {
  return update(draft, {
    attachments: { $push: attachments },
  });
};

export const getMentionsHtml = (item, searchText) => {
  const highlightedText = searchText
    ? highlightTextWithCustomStyle(item, searchText)
    : item;

  return ReactDOMServer.renderToStaticMarkup(
    <span
      style={{ color: colors.textLink }}
      dangerouslySetInnerHTML={{ __html: `@${highlightedText}` }}
    />
  );
};

export const renderLinkInMessage = ({ match, searchText }) => {
  const href = match.getAnchorHref();
  const anchorText = match.getAnchorText();
  const highlightedText = searchText
    ? highlightText(anchorText, searchText)
    : anchorText;

  return ReactDOMServer.renderToStaticMarkup(
    <a
      href={href}
      aria-label={anchorText}
      target="_blank"
      rel="noopener noreferrer"
      dangerouslySetInnerHTML={{ __html: highlightedText }}
    />
  );
};

export const getProfileItem = ({
  user,
  defaultNameSortPreference,
  defaultStudentNameOrderPreference,
}) => {
  const imageUrl = _.get(user, "profileImage", "");
  const id = _.get(user, "id");
  const value = getFormattedNameForUserType({
    user,
    orderBy: defaultNameSortPreference,
    defaultStudentNameOrderPreference,
    isFormattedNameV2: true,
  });
  return { imageUrl, id, value };
};

export const QUERY_PARAMS = {
  MESSAGE_ID: "mId",
  USER_ID: "uId",
  MESSAGE_CURSOR: "mc",
  CHAT_ID: "cId",
  SEARCH_TEXT: "s",
  TYPE_FILTER: "t",
  TEMPLATE_ID: "tId",
  TAB_KEY: "tKey",
};

export const getCursorMsgFromSearch = search => {
  const query = new URLSearchParams(search);
  const queryMessageId = query.get(QUERY_PARAMS.MESSAGE_ID);
  const queryMsgCursor = query.get(QUERY_PARAMS.MESSAGE_CURSOR);
  if (queryMsgCursor && queryMessageId) {
    return { id: queryMessageId, cursor: queryMsgCursor };
  }
  return undefined;
};

export const generateOverviewQueryParams = ({ userId, name }) => {
  const overviewQueryParams = {
    [QUERY_PARAMS.USER_ID]: userId,
    [QUERY_PARAMS.SEARCH_TEXT]: name,
  };

  const searchParams = new URLSearchParams(overviewQueryParams);
  const searchString = searchParams.toString();
  return searchString;
};

export const generateMessagingQueryParams = ({
  messageId,
  messageCursor,
  chatId = null,
  searchText = null,
}) => {
  const messageQueryParamsObj = {
    // a small hack to change the url, so that the component consuming
    // this re-renders even when user searches for the same message
    tm: moment().valueOf(),
  };

  if (messageId) {
    messageQueryParamsObj[QUERY_PARAMS.MESSAGE_ID] = messageId;
  }

  if (messageCursor) {
    messageQueryParamsObj[QUERY_PARAMS.MESSAGE_CURSOR] = messageCursor;
  }

  //if messaging ui revemp enabled then we are opening view mode in side panel , so here appending chat id in query params itself
  if (isMessagingRevempEnabled() && chatId) {
    messageQueryParamsObj[QUERY_PARAMS.CHAT_ID] = chatId;
  }

  if (isMessagingRevempEnabled() && searchText) {
    messageQueryParamsObj[QUERY_PARAMS.SEARCH_TEXT] = searchText;
  }

  const searchParams = new URLSearchParams(messageQueryParamsObj);
  const searchString = searchParams.toString();

  return searchString;
};

export const generateChatQueryParams = ({ chatId, searchText }) => {
  const messageQueryParamsObj = {
    [QUERY_PARAMS.CHAT_ID]: chatId,
    [QUERY_PARAMS.SEARCH_TEXT]: searchText,
  };
  const searchParams = new URLSearchParams(messageQueryParamsObj);
  const searchString = searchParams.toString();
  return searchString;
};

export const NEW_FORM_ID = "new";

// messageId ,templateId,tabKey is optional
export const generateFormQueryParams = ({
  chatId,
  messageId,
  templateId,
  tabKey,
}) => {
  const formQueryParamsObj = {
    [QUERY_PARAMS.CHAT_ID]: chatId,
    ...(messageId ? { [QUERY_PARAMS.MESSAGE_ID]: messageId } : {}),
    ...(templateId ? { [QUERY_PARAMS.TEMPLATE_ID]: templateId } : {}),
    ...(tabKey ? { [QUERY_PARAMS.TAB_KEY]: tabKey } : {}),
  };

  const searchParams = new URLSearchParams(formQueryParamsObj);
  const searchString = searchParams.toString();
  return searchString;
};

export const getMessagingFormRoute = ({
  chatId,
  messageId,
  formId = NEW_FORM_ID,
  templateId,
}) => {
  const formQueryParams = generateFormQueryParams({
    chatId,
    messageId,
    templateId,
  });
  return `messaging/forms/${formId}?${formQueryParams}`;
};

export const getMessagingFormTemplateRoute = ({
  chatId,
  templateId = NEW_FORM_ID,
  tabKey,
}) => {
  const formQueryParams = generateFormQueryParams({ chatId, tabKey });
  return `messaging/form-templates/${templateId}?${formQueryParams}`;
};

export const isNewFormId = formId => _.isEqual(formId, NEW_FORM_ID);

export const getMessagingDetailsRoute = ({ id }) => `messaging/${id}`;
export const getMessagingViewDetailsRoute = ({ id }) => `chats/${id}`;
export const getMessagingDepartmentDetailRoute = ({ id }) =>
  `messaging/department-${id}`;

export const getIsDepartmentId = id => _.startsWith(id, "department-");

export const getDepartmentId = id => _.last(_.split(id, "department-"));

export const isDepartmentSelected = (chatId, id) => {
  if (!_.isString(chatId) || !_.startsWith(chatId, "department-")) return false;
  const depId = getDepartmentId(chatId);
  return isIdEqual(depId, id);
};

export const getIsMessagingWidget = ({ screenMode }) =>
  screenMode === CHAT_SCREEN_MODE.WIDGET;

export const getIsViewMode = ({ screenMode }) =>
  screenMode === CHAT_SCREEN_MODE.VIEW_MODE_SCREEN;

export const getIsFullScreenMode = ({ screenMode }) =>
  screenMode === CHAT_SCREEN_MODE.FULL_SCREEN;

export const getIsSidePaneMode = ({ screenMode }) =>
  screenMode === CHAT_SCREEN_MODE.SIDE_PANE;

// MIXPANEL event tracking utils functions
export const recordMessagingModuleOpened = ({ from }) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.MESSAGING_OPENED,
    eventData: {
      from,
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordMessagingModuleAdminPanelOpened = () => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.MESSAGING_ADMIN_PANEL_OPENED,
    eventData: {
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordMessagingFilters = ({ value }) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.MESSAGING_FILTER,
    eventData: {
      value,
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordThreadListV2TabChange = tab => {
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.THREAD_TAB_CHANGED,
    eventData: {
      value: tab,
      messagingVersion: MESSAGING_VERSION.V2,
    },
  });
};

export const recordMessageV2ChannelCreation = ({ type, from }) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.CHANNEL_CREATED,
    eventData: {
      type,
      from,
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordChatActions = ({ action, from, chatId, chatType }) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.CHAT_ACTIONS,
    eventData: {
      action,
      from,
      chatId,
      chatType,
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordChannelActions = ({ type, mode = "EDIT" }) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.CHANNEL_ACTIONS,
    eventData: {
      type,
      mode,
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordMessagingSearchFilter = ({ type }) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.MESSAGING_SEARCH_FILTER,
    eventData: {
      type,
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};
export const recordMessagingWidgetExpand = ({ chatId, chatType } = {}) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.MESSAGING_WIDGET_EXPAND,
    eventData: {
      chatId,
      chatType,
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordMessagingViewModeOpened = ({ type }) => {
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.MESSAGING_VIEW_MODE_OPENED,
    eventData: {
      type,
      messagingVersion: MESSAGING_VERSION.V1,
    },
  });
};

export const recordMessagingSearchResultSelect = ({ type }) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.MESSAGING_SEARCH_RESULT_SELECT,
    eventData: {
      type,
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordMessagingMessageActions = ({ type, messageId }) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.MESSAGE_ACTIONS,
    eventData: {
      type,
      messageId,
      isFailedMessage: getIsLocalMessage(messageId),
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordMessagingModuleSettingUpdate = ({ configurationNames }) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.MESSAGING_MODULE_SETTING_UPDATE,
    eventData: {
      configurationNames,
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordMessagingChatAccessed = ({
  from,
  currentUserType,
  recipientUserType,
}) => {
  const isUIRevempEnabled = isMessagingRevempEnabled();

  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.CHAT_ACCESSED,
    eventData: {
      from,
      currentUserType,
      recipientUserType,
      messagingVersion: isUIRevempEnabled
        ? MESSAGING_VERSION.V2
        : MESSAGING_VERSION.V1,
    },
  });
};

export const recordViewConversationClicked = ({ from }) => {
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.VIEW_CONVERSATION_CLICKED,
    eventData: {
      from,
      messagingVersion: MESSAGING_VERSION.V2,
    },
  });
};

export const recordOverviewAction = ({ action }) => {
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.OVERVIEW_ACTION,
    eventData: {
      action,
      messagingVersion: MESSAGING_VERSION.V2,
    },
  });
};

export const recordPageVisited = ({ page }) => {
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.PAGE_VISITED,
    eventData: {
      page,
      messagingVersion: MESSAGING_VERSION.V2,
    },
  });
};

export const recordMessagingSearchPageTabChange = ({ tab }) => {
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.MESSAGING_SEARCH_PAGE_TAB,
    eventData: {
      tab,
      messagingVersion: MESSAGING_VERSION.V2,
    },
  });
};

export const recordMessagingSearchPageAction = ({ type }) => {
  recordEvent({
    eventName:
      MESSAGING_ANALYTICS_EVENT_NAME.MESSAGING_SEARCH_PAGE_OPTION_SELECT,
    eventData: {
      type,
      messagingVersion: MESSAGING_VERSION.V2,
    },
  });
};

export const recordOverviewSearchResultSelect = ({ type }) => {
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.OVERVIEW_SEARCH_RESULT_SELECT,
    eventData: {
      type,
      messagingVersion: MESSAGING_VERSION.V2,
    },
  });
};

export const recordOverviewChatOpened = ({ type }) => {
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.OVERVIEW_CHAT_OPENED,
    eventData: {
      type,
      messagingVersion: MESSAGING_VERSION.V2,
    },
  });
};

export const recordSuggestionsClicked = ({ chatType, from }) => {
  recordEvent({
    eventName: MESSAGING_ANALYTICS_EVENT_NAME.SUGGESTION_PRESSED,
    eventData: {
      chatType,
      from,
      messagingVersion: MESSAGING_VERSION.V2,
    },
  });
};

export const getSearchScreenFilterOptions = ({ t, activeTab, isStaff }) => {
  switch (activeTab) {
    case SEARCH_ALL_SCREEN_TABS_CONSTANTS.MESSAGES:
      return [];
    case SEARCH_ALL_SCREEN_TABS_CONSTANTS.MEMBERS:
      return [
        {
          value: STAFF,
          label: t("common:staff_members_plural"),
          prefixElement: (
            <ClassChannelOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
        {
          value: STUDENT,
          label: t("common:student_plural"),
          prefixElement: (
            <StudentOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
        {
          value: PARENT,
          label: t("common:family_member_plural"),
          prefixElement: (
            <FamilyOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
      ];
    case SEARCH_ALL_SCREEN_TABS_CONSTANTS.CHANNELS: {
      const isPublicChannelEnabled = isMessagingPublicChannelEnabled();
      const isDepartmentChannelEnable = isMessagingDepartmentChannelEnabled();
      return [
        ...(!getIsParent()
          ? [
              {
                value: CHANNEL_TYPES.CHANNEL_SYSTEM_MANAGED,
                label: t("common:class_channel"),
                prefixElement: (
                  <ClassChannelOutlined variant={"subtle"} size={"xx-small"} />
                ),
              },
            ]
          : []),
        {
          value: CHANNEL_TYPES.CHANNEL_CUSTOM,
          label: isPublicChannelEnabled
            ? t("common:private_channel")
            : t("common:custom_channel"),
          prefixElement: (
            <CustomChannelOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
        ...(!getIsStudent()
          ? [
              {
                value: CHANNEL_TYPES.CHANNEL_FAMILY,
                label: t("common:family_channel"),
                prefixElement: (
                  <FamilyChannelOutlined variant={"subtle"} size={"xx-small"} />
                ),
              },
            ]
          : []),
        ...(isPublicChannelEnabled
          ? [
              {
                value: CHANNEL_TYPES.CHANNEL_PUBLIC,
                label: t("common:public_channel"),
                prefixElement: (
                  <GlobeOutlined variant={"subtle"} size={"xx-small"} />
                ),
              },
            ]
          : []),

        ...(isDepartmentChannelEnable && (getIsStaff() || getIsParent())
          ? [
              {
                value: CHANNEL_TYPES.CHANNEL_DEPARTMENT,
                label: t("common:department_channel"),
                prefixElement: (
                  <CustomChannelOutlined variant={"subtle"} size={"xx-small"} />
                ),
              },
            ]
          : []),
      ];
    }
    case SEARCH_ALL_SCREEN_TABS_CONSTANTS.FILES:
      return [
        {
          value: "IMAGE",
          label: t("common:image"),
          prefixElement: (
            <ImageSquareOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
        {
          value: "VIDEO",
          label: t("common:video"),
          prefixElement: <VideoOutlined variant={"subtle"} size={"xx-small"} />,
        },
        {
          value: "PDF",
          label: t("schoolSetup:pdf"),
          prefixElement: <PdfOutlined variant={"subtle"} size={"xx-small"} />,
        },
        {
          value: "DOC",
          label: t("common:doc"),
          prefixElement: (
            <PageSquareOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
        {
          value: "SHEETS",
          label: t("common:sheet_text"),
          prefixElement: (
            <SheetsOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
        {
          value: "SLIDES",
          label: t("common:slide_text"),
          prefixElement: (
            <SlidesOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
        {
          value: "AUDIO",
          label: t("common:audio"),
          prefixElement: (
            <VolumeHighOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
        {
          value: "LINK",
          label: t("common:link"),
          prefixElement: <LinkOutlined variant={"subtle"} size={"xx-small"} />,
        },

        {
          value: "ZIP",
          label: t("common:zip"),
          prefixElement: (
            <ZipFileOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
        {
          value: INTERACTION_TYPE.POLL,
          label: t("common:polls"),
          prefixElement: <PollOutlined variant={"subtle"} size={"xx-small"} />,
        },
        {
          value: INTERACTION_TYPE.FORM,
          label: t("common:forms"),
          prefixElement: (
            <PageFoldPortraitOutlined variant={"subtle"} size={"xx-small"} />
          ),
        },
      ];
  }
};

export const CHAT_BAR_DROPDOWN_ACTION = {
  CREATE_POLL: "create_poll",
  CREATE_NEW_FORM: "create_new_form",
  SELECT_FORM_TEMPLATE: "select_form_template",
};

// utils to get drop down options for chat bar
export const getChatBarDropDownOptions = ({ isChat }) => {
  const UPLOAD_AND_ADD_OPTIONS = [
    {
      label: "common:upload",
      key: "UPLOAD",
      isItemGroup: true,
      options: [
        {
          key: "upload_device",
          label: "common:device",
          icon: <DeviceDesktopOutlined variant={"subtle"} />,
        },
        {
          key: "add_google_drive",
          label: "common:google_drive",
          icon: <GoogleDriveColored />,
        },
        {
          key: "add_one_drive",
          label: "common:one_drive",
          icon: <OneDriveColored />,
        },
      ],
    },
    {
      label: "common:add",
      key: "ADD",
      isItemGroup: true,
      options: [
        {
          key: "add_link",
          label: "common:link",
          icon: <LinkOutlined variant={"subtle"} />,
        },
      ],
    },
  ];

  const isStaff = getIsStaff();

  const isPollEnabled = !isChat && isStaff && isMessagingPollEnabled();
  const isFormEnabled = !isChat && isStaff && isMessagingFormEnabled();

  const CREATE_OPTIONS =
    isPollEnabled || isFormEnabled
      ? [
          {
            label: "common:create",
            key: "CREATE",
            isItemGroup: true,
            options: [
              ...(isPollEnabled
                ? [
                    {
                      key: CHAT_BAR_DROPDOWN_ACTION.CREATE_POLL,
                      label: "common:polls",
                      icon: <PollOutlined variant="subtle" />,
                    },
                  ]
                : []),
              ...(isFormEnabled
                ? [
                    {
                      isSubMenu: true,
                      key: "create_forms",
                      label: "common:forms",
                      icon: <PageFoldPortraitOutlined variant="subtle" />,
                      options: [
                        {
                          key: CHAT_BAR_DROPDOWN_ACTION.CREATE_NEW_FORM,
                          label: "common:create_new",
                          icon: <AddOutlined variant="subtle" />,
                        },
                        {
                          key: CHAT_BAR_DROPDOWN_ACTION.SELECT_FORM_TEMPLATE,
                          label: "common:select_a_template",
                          icon: <AssessmentAddOutlined variant="subtle" />,
                        },
                      ],
                    },
                  ]
                : []),
            ],
          },
        ]
      : [];

  const CAPTURE_OPTIONS = [
    {
      label: "common:capture",
      key: "CAPTURE",
      isItemGroup: true,
      options: [
        {
          key: "capture_image",
          label: "common:image",
          icon: <CameraOutlined variant={"subtle"} />,
        },
        {
          key: "capture_video",
          label: "common:video",
          icon: <VideoOutlined variant={"subtle"} />,
        },
      ],
    },
  ];

  const allOptions = [
    ...UPLOAD_AND_ADD_OPTIONS,
    ...CREATE_OPTIONS,
    ...CAPTURE_OPTIONS,
  ];
  return allOptions;
};

export const getMessageLabelAndAttachmentsForReplyContainer = ({ message }) => {
  const isForwardedMessage = _.isEqual(
    _.get(message, "parentMessage.type"),
    MESSAGE_TYPE.FORWARDED_MESSAGE,
    MESSAGE_TYPE.NORMAL
  );

  const { label, attachments = [], parentMessage } = message;
  if (isForwardedMessage) {
    const newLabel = label ? label : _.get(parentMessage, "label");
    const newAttachments =
      !label && !_.size(attachments)
        ? _.get(parentMessage, "attachments", [])
        : attachments;
    return {
      ...message,
      label: newLabel,
      attachments: newAttachments,
    };
  }

  return message;
};

export const MESSAGING_FILTERS = {
  [MESSAGING_FILTERS_CONSTANTS.ALL]: {
    label: "common:all",
    value: MESSAGING_FILTERS_CONSTANTS.ALL,
    threadLabel: "common:recent_conversation",
    visibleUserTypes: [STAFF, STUDENT, PARENT],
    disabled: true,
  },
  [MESSAGING_FILTERS_CONSTANTS.UNREAD]: {
    label: "common:unread_capital",
    value: MESSAGING_FILTERS_CONSTANTS.UNREAD,
    countKey: "unreadChatCounts",
    visibleUserTypes: [STUDENT, PARENT, STAFF],
  },
  [MESSAGING_FILTERS_CONSTANTS.STUDENT]: {
    label: "common:student_plural",
    value: MESSAGING_FILTERS_CONSTANTS.STUDENT,
    visibleUserTypes: [STAFF],
  },
  [MESSAGING_FILTERS_CONSTANTS.FAMILY]: {
    label: "common:family_plural",
    value: MESSAGING_FILTERS_CONSTANTS.FAMILY,
    visibleUserTypes: [STAFF],
  },
  [MESSAGING_FILTERS_CONSTANTS.STAFF]: {
    label: "common:staff",
    value: MESSAGING_FILTERS_CONSTANTS.STAFF,
    visibleUserTypes: [STUDENT, PARENT, STAFF],
  },
  [MESSAGING_FILTERS_CONSTANTS.DEPARTMENT_CHANNEL]: {
    label: "common:department_other",
    value: MESSAGING_FILTERS_CONSTANTS.DEPARTMENT_CHANNEL,
    visibleUserTypes: [STAFF, PARENT],
  },
  [MESSAGING_FILTERS_CONSTANTS.PUBLIC_CHANNEL]: {
    label: "common:public_channels",
    value: MESSAGING_FILTERS_CONSTANTS.PUBLIC_CHANNEL,
    visibleUserTypes: [STAFF, STUDENT, PARENT],
  },
};

export const getUserTypeOption = ({ t }) => [
  {
    value: STAFF,
    label: t("common:staff"),
  },
  {
    value: STUDENT,
    label: t("common:student_other"),
  },
  {
    value: PARENT,
    label: t("common:family_plural"),
  },
  {
    value: YEAR_GROUP,
    label: t("common:year_group"),
  },
  {
    value: GRADE,
    label: t("common:grades"),
  },
  {
    value: CLASSES,
    label: t("common:class_other"),
  },
];

export const unifiedToNative = unified => {
  const uniCodes = _.split(unified, "-");
  const codePoints = _.map(uniCodes, u => parseInt(u, 16));

  return String.fromCodePoint(...codePoints);
};

export const isDualPanelManagerV2Enabled = () => {
  return ACLStore.can(DUAL_PANEL_MANAGER_V2_CONFIG);
};

export const isDualPanelManagerV3Enabled = () => {
  return ACLStore.can(DUAL_PANEL_MANAGER_V3_CONFIG);
};

export const isDualPanelRevampEnabled = () =>
  isDualPanelManagerV3Enabled() || isDualPanelManagerV2Enabled();

export const getMessagingBaseRoute = ({
  isCombinedCurriculumHomePage,
  isAdminTab,
  isAccountPortal = false,
  curriculumId,
} = {}) => {
  if (isCombinedCurriculumHomePage) {
    return "platform/my-home";
  }
  if (isAdminTab) {
    return "platform/administrator";
  }
  if (isAccountPortal) {
    return "platform";
  }
  return `platform/${curriculumId}`;
};
